/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import API, { handleCancelRequest } from "../../utils/API";
import Dropdown from "./components/Dropdown";
import MyTasks from "./components/MyTasks";
import { useDispatch, useSelector } from "react-redux";
import { setProject } from "../../utils/redux/app/appActions";

const Dashboard = ({ user }) => {
  const { projects, project } = useSelector((state) => state.app);
  const [tasks, setTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [noProjects, setNoProjects] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      handleCancelRequest();
    };
  }, []);

  useEffect(() => {
    if (projects?.length === 1) {
      dispatch(setProject(projects[0]));
    } else if (projects?.length === 0) {
      setNoProjects(true);
    }
  }, [projects, dispatch]);

  const getTasks = () => {
    setIsLoading(true);
    const url = `tasks/filters?project_id=${project.id}&page=1&size=10&user_id=${user.id}`;
    API.postData(url)
      .then(({ data: res }) => {
        const tasksList = determineTasksStatus(res.data);
        setTasks(tasksList);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const determineTasksStatus = (tasks) => {
    let statusNo = 0;
    return tasks.map((task) => {
      if (task.color === "#a30909") {
        statusNo = 1;
      } else if (task.color === "#147103") {
        statusNo = 2;
      } else if (task.color === "#bc3a06") {
        statusNo = 3;
      } else {
        statusNo = 0;
      }

      return {
        ...task,
        statusNo,
      };
    });
  };

  useEffect(() => {
    if (project) {
      getTasks();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project]);

  return (
    <div className="Dashboard">
      <div className="container-fluid">
          <div className="row">
            <div className="col d-flex justify-content-center">
              <Dropdown/>
            </div>
          </div>

        <div className="row">
          <div className="col">
            <MyTasks
              tasks={tasks}
              project={project}
              isLoading={isLoading}
              noProjects={noProjects}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
